/**
 * Footer helper
 *
 * @author Matej Svajger <hello@matejsvajger.com>
 */

'use strict';

export default class Footer {

    constructor() {

        App.dispatcher.listen('breakpoint.xs', () => {
            this.hideAll();
        });

        App.dispatcher.listen('breakpoint.sm', () => {
            this.hideAll();
            this.showInfo();
            this.showDelivery();
        });

        App.dispatcher.listen('breakpoint.md', () => {
            this.showAll();
        });

    }

    showInfo() {
        document.getElementById('collapse-info-links').classList.add("show");
    }

    hideInfo() {
        document.getElementById('collapse-info-links').classList.remove("show");
    }

    showAbout() {
        document.getElementById('collapse-about').classList.add("show");
    }

    hideAbout() {
        document.getElementById('collapse-about').classList.remove("show");
    }

    showContacts() {
        document.getElementById('collapse-contact').classList.add("show");
    }

    hideContacts() {
        document.getElementById('collapse-contact').classList.remove("show");
    }

    hideDelivery() {
        if(document.getElementById('delivery')) {
            document.getElementById('delivery').classList.remove("show");
        }
    }

    showDelivery() {
        if(document.getElementById('delivery')) {
            document.getElementById('delivery').classList.add("show");
        }
    }

    showAll() {
        this.showInfo();
        this.showAbout();
        this.showContacts();
        this.showDelivery();
    }

    hideAll() {
        this.hideInfo();
        this.hideAbout();
        this.hideContacts();
        this.hideDelivery();
    }

}
